import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {GuukListadoActivacionesComponent} from './components/guuk-listado-activaciones/guuk-listado-activaciones.component';
import {GuukOrderDetailComponent} from './components/guuk-order-detail/guuk-order-detail.component';

const routes: Routes = [
    {path: 'listado', component: GuukListadoActivacionesComponent},
    {path: 'order/:order_id', component: GuukOrderDetailComponent},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class GuukRoutingModule {
}
